export default __webpack_public_path__ + "static/media/google.3509ff96.png";